import { QueryTuple, useLazyQuery } from '@apollo/client';
import { ROD_REQUESTS } from '@bechtel/client-gql';
import { PagingInput, RodRequest, RodRequestFilterInput } from '@bechtel/types';

export function useRodRequestsQuery(
  fetchFromNetwork?: boolean
): QueryTuple<{ rodRequests: RodRequest[]; input: RodRequestFilterInput; paging: PagingInput }, Record<string, any>> {
  const response = useLazyQuery<{
    rodRequests: RodRequest[];
    input: RodRequestFilterInput;
    paging: PagingInput;
  }>(
    ROD_REQUESTS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
